import { Controller } from "@hotwired/stimulus"

/**
 * Sound Preview Controller
 *
 * Plays audio previews for sound effects. Ensures only one sound
 * plays at a time — clicking a new preview stops the current one.
 */
export default class extends Controller {
  static values = {
    url: String,
  }

  connect() {
    this.audio = null
  }

  disconnect() {
    this.stop()
  }

  play(event) {
    event.preventDefault()
    event.stopPropagation()

    const url = event.params?.url || this.urlValue
    if (!url) return

    // Stop any currently playing audio
    this.stop()

    this.audio = new Audio(url)
    this.audio.volume = 0.8
    this.audio.play().catch(() => {
      // Ignore autoplay errors
    })
  }

  toggle(event) {
    event.preventDefault()

    if (this.audio && !this.audio.paused) {
      this.stop()
    } else {
      const url = this.urlValue
      if (!url) return

      this.audio = new Audio(url)
      this.audio.volume = 0.8
      this.audio.play().catch(() => {})
    }
  }

  stop() {
    if (this.audio) {
      this.audio.pause()
      this.audio.currentTime = 0
      this.audio = null
    }
  }
}
